// extracted by mini-css-extract-plugin
module.exports = {"read-more-message-hide":"ReadMore_read-more-message-hide__Lenz6","read-more-button":"ReadMore_read-more-button__kbWJA","less-pdp-msg":"ReadMore_less-pdp-msg__8euGI"};